import { getString } from "../../../../strings";
import { StyledDataWrapper } from '../../../molecules/UserPanel/StyledDataWrapper';
import { StyledText } from "../../../atoms/Text/StyledText";
import TournamentsCompetitions from "../../../molecules/Tournaments/TournamentsCompetitions";

const UserCompetitions = ({ competitions }) => {
    return (
        <StyledDataWrapper>
            <StyledText
                hasdeclaredfontsize="20px"
                hasdeclaredfontweight="600"
                hasdeclaredfontcolor="#4E6BAA"
                hasdeclaredpadding="0 8px 0 0"
            >
                {getString('userPanel_userPanelTournament_mojeKonkurencje')}
            </StyledText>

            <TournamentsCompetitions
                competitions={competitions}
                size="18px"
            />
        </StyledDataWrapper>
    );
};

export default UserCompetitions;